import {
  dateStringToDateBR,
  formataDataYYYYMMDD,
  formatDateTimeBRWithoutSeconds,
  montaDataExame
} from '../utils/date-validator'
import { limparTexto, normalizaSexo } from '../utils/text-format'
import BaseMixin from './base.mixin'
import qs from 'qs'
import CONSTANTS from '../constants/constants'
import axios from 'axios'

const local = JSON.parse(localStorage.getItem('user'))
let token = null
let refreshToken = null

const baseUrl = import.meta.env.VITE_URL_API

if (local) {
  token = local.token
  refreshToken = local.refreshToken
}

function adaptExamApiToGrid(item) {
  const modality = (item.modality || '').toUpperCase()
  const prioridade = item.prioridade || CONSTANTS.DICOM_PLUS_PRIORIDADE.ROTINA

  return {
    dicomPlusID: item.dicomPlusID,
    studyInstanceUID: item.studyInstanceUID,
    accessionNumber: item.accessionNumber,
    stationName: item.stationName,
    unidade: item.sourceRequestorName,
    fonteID: item.fonteID,
    categoria: modality,
    especialidade: item.especialidadeID,
    especialidadeID: item.especialidadeID,
    paciente: item.patientName,
    socialName: item.patientSocialName,
    patientID: item.patientID,
    dataNascimento: dateStringToDateBR(item.patientBirthDate),
    idade: item.patientAge,
    sexo: normalizaSexo(item.patientSex),
    estudo: item.descricaoEspecialidade || '',
    comentarios: item.patientComments,
    tituloLaudo: item.tituloLaudo,
    created_at: item.created_at,
    processed_at: item.processed_at,
    nu_firstreceivetimestamp: item.nu_firstreceivetimestamp,
    tagsPlus: item.tagsPlus,
    status: item.status,
    dataExame: montaDataExame(item.studyDate, item.studyTime, item.created_at),
    studyTime: item.studyTime,
    studyDate: item.studyDate,
    requestingPhysicianName: item.requestingPhysicianName,
    patientWeight: item.patientWeight,
    token: item.token,
    subEspecialidade: item.subEspecialidade,
    contraste: item.contraste,
    contrasteVia: item.contrasteVia,
    contrasteTipo: item.contrasteTipo,
    trauma: item.trauma,
    avc: item.avc,
    leito: item.leito,
    oncologico: item.oncologico,
    prioridade,
    mamografia: item.mamografia,
    emUso: item.emUso,
    usuarioEmUso: item.usuarioEmUso,
    usuarioAtualizacao: item.usuarioAtualizacao,
    falha: item.falha,
    exameID: item.exameID,
    fonteEmergenciaOpcional: item.fonteEmergenciaOpcional,
    examStatus: item.examStatus,
    enviaParaGSaudeApp: item.enviaParaGSaudeApp,
    socAtivo: item.socAtivo,
    procedimentoID: item.procedimentoID,
    dataRecebimento: formatDateTimeBRWithoutSeconds(item.dataRecebimento),
    medicoID: item.medicoID,
    nomeMedico: item.nomeMedico,
    exameCriado: item.exameCriado,
    exigePedidoMedico: item.exigePedidoMedico ?? item.ExigePedidoMedico ?? false
  }
}

const mixin = {
  mixins: [BaseMixin],
  methods: {
    async getDicomPlus(
      filters = null,
      Page = 1,
      pageSize = 5,
      OrderColumn = '',
      OrderBy = 'desc',
      tiporegistro = null
    ) {
      const searchValue = filters && filters.patientName && filters.patientName.value
      const isNumericSearch = !!searchValue && /^\d+$/.test(String(searchValue).trim())

      const params = {
        ...(searchValue
          ? isNumericSearch
            ? { DicomPlusId: String(searchValue).trim() }
            : { PatientName: searchValue }
          : {}),
        Page,
        pageSize,
        ...(tiporegistro !== null ? { tiporegistro } : {})
      }

      if (OrderColumn && OrderColumn !== '') {
        params.OrderColumn = OrderColumn
        params.OrderBy = OrderBy
      }

      if (filters) {
        Object.entries(filters).forEach(([key, obj]) => {
          if (key === 'patientName' && isNumericSearch) return
          let value = obj.value
          if (value && typeof value === 'object' && 'id' in value) {
            value = value.id
          }
          if (value !== undefined && value !== null && value !== '') {
            params[key] = value
          }
        })
      }

      const url = '/core/DicomPlus'
      const res = await this.getClient().get(url, {
        headers: {
          Authorization: token,
          RefreshToken: refreshToken
        },
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
      })
      const data = res.data?.data

      const apiItems = data
      const total = res.data.total || apiItems.length
      const pageCount = res.data.pageCount || Math.ceil(total / pageSize)
      const items = apiItems.map(adaptExamApiToGrid)
      return { items, total, pageCount }
    },

    async getDadosPorPaciente(dados) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      let dicomPlusID = dados
      if (typeof dados === 'object' && dados !== null) {
        dicomPlusID = dados.dicomPlusID
      }

      if (!dicomPlusID) {
        throw new Error('DicomPlusID não informado!')
      }

      const url = `${baseUrl}/core/DicomPlus?DicomPlusID=${dicomPlusID}`
      try {
        const res = await axios.get(url, { headers })
        return res.data.data.map(adaptExamApiToGrid)
      } catch (e) {
        throw e.response.data.errors
      }
    },

    // Atualizar dados do paciente (modal)
    async updatePaciente(dadosPaciente, continueWithNameNotSimilar = false) {
      const studyInstanceUID = dadosPaciente.studyInstanceUID || dadosPaciente.StudyInstanceUID
      if (!studyInstanceUID) {
        throw new Error('StudyInstanceUID é obrigatório para atualizar paciente')
      }

      const url = `${baseUrl}/core/DicomPlus`

      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }

      if (continueWithNameNotSimilar) {
        dadosPaciente.continueWithNameNotSimilar = true
      }

      try {
        const response = await axios.put(url, dadosPaciente, { headers })
        return {
          success: response.status === 200,
          message: response.Response
        }
      } catch (e) {
        throw e.response.data
      }
    },

    async salvarDuplicacaoAPI(payload) {
      const url = `${baseUrl}/core/DicomPlus/Duplicate`
      const local = JSON.parse(localStorage.getItem('user'))
      const token = local.token
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      try {
        const response = await axios.post(url, payload, { headers })
        return {
          success: response.status === 200,
          message: response.Response
        }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async getCategoriasDicomPlus() {
      const url = `${baseUrl}/core/DicomPlus/ModalityList`

      const res = await axios.get(url, {
        headers: {
          Authorization: token,
          RefreshToken: refreshToken
        }
      })

      const data = res.data?.data || []
      const categorias = data
        .map((item) => {
          const modalityRaw = (item.modalityID || '').toUpperCase()
          const modality = CONSTANTS.DICOM_PLUS_MODALIDADE_ALIAS[modalityRaw] || modalityRaw

          return {
            id: modality,
            name: modality,
            value: modality,
            label: modality,
            modalityID: modality
          }
        })
        .sort((a, b) => a.label.localeCompare(b.label))

      return { categorias }
    },
    getFileTypes() {
      const tipos = [
        { value: 1, label: 'Exame anterior' },
        { value: 2, label: 'Anamnese' },
        { value: 3, label: 'Laudo anterior' },
        { value: 4, label: 'Pedido médico' },
        { value: 5, label: 'Exame criado' }
      ]
      // Pedido médico é o anexo mais usado: fica fixo no topo e os demais em ordem alfabética.
      const pedidoMedico = tipos.filter(tipo => tipo.value === CONSTANTS.DICOM_PLUS_TIPO_ANEXO.PEDIDO_MEDICO)
      const demais = tipos
        .filter(tipo => tipo.value !== CONSTANTS.DICOM_PLUS_TIPO_ANEXO.PEDIDO_MEDICO)
        .sort((a, b) => a.label.localeCompare(b.label))
      return [...pedidoMedico, ...demais]
    },
    getStatus() {
      return [
        { label: 'Pendente', value: 0 },
        { label: 'Revisado', value: 1 },
        { label: 'Exame criado', value: 2 },
        { label: 'Falha', value: 3 },
        { label: 'Expirado', value: 4 },
        { label: 'Deletado', value: 5 },
        { label: 'Cancelado', value: 99 }
      ]
    },

    async salvarCategoria(dados) {
      const StudyInstanceUID = dados.StudyInstanceUID || dados.studyInstanceUID
      if (!StudyInstanceUID) {
        throw new Error('É preciso informar StudyInstanceUID')
      }

      const url = `${baseUrl}/core/DicomPlus/UpdateModality`

      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      try {
        await axios.put(url, dados, { headers })
        return true
      } catch (e) {
        throw e.response.data.errors
      }
    },

    async getSpecialityList(modality) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      const client = this.getClient && this.getClient()
      if (!client) {
        return []
      }

      const url = `/core/DicomPlus/Speciality?ModalityID=${modality}`
      const res = await client.get(url, headers)
      const data = res.data?.data || []
      return data.map((item) => ({
        label: item.specialityName,
        value: item.specialityID,
        procedimentos: item.procedimentos || []
      }))
    },

    async getContrastTypes() {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      const url = `/core/DicomPlus/Contrast`
      const res = await this.getClient().get(url, headers)
      const data = res.data?.data || []

      const opcoesVia = data
        .filter((item) => item.tipo === 1)
        .sort((a, b) => a.descricao.localeCompare(b.descricao))
        .map((item) => ({
          label: item.descricao,
          value: item.contrasteID
        }))

      const opcoesTipo = data
        .filter((item) => item.tipo === 2)
        .sort((a, b) => a.descricao.localeCompare(b.descricao))
        .map((item) => ({
          label: item.descricao,
          value: item.contrasteID
        }))

      return { via: opcoesVia, tipo: opcoesTipo }
    },

    getPriority() {
      return [
        { label: 'Rotina', value: 1 },
        { label: 'Urgência', value: 2 },
        { label: 'Emergência', value: 3 }
      ]
    },

    async getExamXView(studyInstanceUID) {
      const res = await this.requestGet(`/core/DicomPlus/MedicalReportDocuments/${studyInstanceUID}`)
      return res.data
    },
    async getDadosComplementares(fonteID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      const url = `/core/PtmSyncPlus/${fonteID}`
      const res = await this.getClient().get(url, headers)
      return res.data?.data || []
    },
    async getFileList(dicomPlusID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      const res = await this.getClient().get(`/core/DicomPlus/File/${dicomPlusID}`, headers)
      const data = res.data
      return data
    },
    async deleteFiles(dicomPlusFileID) {
      const url = `${baseUrl}/core/DicomPlus/File/${dicomPlusFileID}`
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      try {
        await axios.delete(url, { headers })
        return { success: true }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    // Salvar arquivos
    async criarUrlAssinadaUploadCloud(file) {
      try {
        const fileName = file.name
        const fileType = file.type || 'application/octet-stream'
        const url = '/core/DicomPlus/File/CreateUploadUrl'

        const local = JSON.parse(localStorage.getItem('user'))
        const token = local.token
        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const { data } = await this.getClient().post(url, { fileName, fileType }, headers)

        return {
          success: true,
          uploadUrl: data.data.signedUrl,
          publicUrl: data.data.objectPath
        }
      } catch (e) {
        const errorMessage = e?.message || e?.response?.data?.message || ''

        const isNetworkOrTimeoutError =
          errorMessage.toLowerCase().includes('network') ||
          errorMessage.toLowerCase().includes('timeout') ||
          e.code === 'ECONNABORTED'

        return {
          success: false,
          message: isNetworkOrTimeoutError ? 'Verifique a Internet' : errorMessage || 'Erro ao fazer upload do arquivo'
        }
      }
    },
    async uploadExameStorage(uploadUrl, file) {
      try {
        await axios.put(uploadUrl, file, {
          headers: {
            'Content-Type': file.type || 'application/octet-stream'
          }
        })

        return { success: true }
      } catch (e) {
        const errorMessage = e?.message || e?.response?.data?.message || ''

        const isNetworkOrTimeoutError =
          errorMessage.toLowerCase().includes('network') ||
          errorMessage.toLowerCase().includes('timeout') ||
          e.code === 'ECONNABORTED'

        return {
          success: false,
          message: isNetworkOrTimeoutError ? 'Verifique a Internet' : errorMessage || 'Erro ao fazer upload do arquivo'
        }
      }
    },
    async salvarAnexoLocal(payload) {
      try {
        const url = `${baseUrl}/core/DicomPlus/File`
        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const { data } = await axios.post(url, payload, { headers })
        return { success: true, data }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async criarUrlAssinadaDownloadCloud(dicomPlusFileID) {
      try {
        const url = `${baseUrl}/core/DicomPlus/File/CreateDownloadUrl/${dicomPlusFileID}`

        const local = JSON.parse(localStorage.getItem('user'))
        const token = local.token
        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const result = await axios.get(url, { headers })

        return {
          success: true,
          url: result.data.data
        }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async isExamAssignedToUser(dicomPlusFileID) {
      try {
        const url = `${baseUrl}/core/DicomPlus/UserChanging/${dicomPlusFileID}`

        const local = JSON.parse(localStorage.getItem('user'))
        const token = local.token
        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const result = await axios.post(url, null, { headers })
        return result
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async removeAssignedUserToExam(dicomPlusID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      try {
        await axios.delete(`${baseUrl}/core/DicomPlus/RemoveUserChanging/${dicomPlusID}`, { headers })
        return { success: true }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async specialityDuplicateValidation(studyInstanceUID, especiliadidadeID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      try {
        const URL = import.meta.env.VITE_URL_API
        const response = await axios.get(
          `${URL}/core/DicomPlus/DuplicateValidation/${studyInstanceUID}/${especiliadidadeID}`,
          { headers }
        )
        return {
          success: response.status === 200,
          message: response.Response
        }
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async getPatientAge(birthDate) {
      try {
        const url = `/core/DicomPlus/PatientAge/${birthDate}`

        const local = JSON.parse(localStorage.getItem('user'))
        const token = local.token
        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const res = await this.getClient().get(url, headers)
        return res.data
      } catch (error) {
        return { success: false }
      }
    },
    async cancelDicomPlus(dicomPlusID, motivoCancelamento) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }

      const url = `${baseUrl}/core/DicomPlus/Cancel`
      const payload = {
        dicomPlusID,
        motivoCancelamento
      }

      await axios.put(url, payload, { headers })
      return true
    },
    async buscarDadosPacienteGestorSaude({ solicitacaoId, modalityID, fonteID, pacienteCpf, pacienteDataNascimento }) {
      try {
        if (!solicitacaoId) throw new Error('O parâmetro solicitacaoId é obrigatório.')

        const params = new URLSearchParams()
        params.append('solicitacao_id', solicitacaoId)
        params.append('modalityID', modalityID)
        params.append('FonteID', fonteID)

        if (pacienteCpf) {
          params.append('paciente_cpf', limparTexto(pacienteCpf))
        }
        if (pacienteDataNascimento) {
          params.append('paciente_data_nascimento', formataDataYYYYMMDD(pacienteDataNascimento))
        }

        const url = `${baseUrl}/core/integration/gestorSaude?${params.toString()}`

        const headers = {
          Authorization: token,
          RefreshToken: refreshToken
        }
        const response = await axios.get(url, { headers })

        const dados = response.data.data
        if (Array.isArray(dados) && dados.length > 0) {
          return dados[0]
        } else {
          return { mensagem: 'Nenhum registro encontrado' }
        }
      } catch (error) {
        throw error.response.data.errors
      }
    },
    async linkSocFile(examId, portalSocId) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }
      const url = `${baseUrl}/core/soc`
      const payload = { examId, portalSocId }
      const response = await axios.post(url, payload, { headers })

      if (response.data?.data !== true) {
        throw new Error('Não foi possível salvar o vínculo SOC.')
      }

      return response.data.data
    },
    async getSocFiles({ cpf, page, pageSize, fonteID, patientName, allFiles }) {
      const params = { cpf, page, pageSize, fonteID, patientName }

      if (allFiles) params.allFiles = true

      const url = `${baseUrl}/core/soc`
      const res = await axios.get(url, {
        headers: {
          Authorization: token,
          RefreshToken: refreshToken
        },
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
      })

      const apiData = res.data.data

      const items = Array.isArray(apiData.data)
        ? apiData.data.map((item) => ({
            ...item,
            portalSocID: item.portalSocId,
            empresaNome: item.companyName,
            pacienteNome: item.name,
            especialidadeCodigo: item.specialityCode,
            especialidadeNome: item.specialityName
          }))
        : []

      const total = apiData.total || 0
      const pageCount = apiData.pageCount || Math.ceil(total / pageSize)

      return { items, total, pageCount }
    },
    async getDicomPlusHistory(dicomPlusID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }

      const url = `${baseUrl}/core/DicomPlus/History/${dicomPlusID}`
      try {
        const res = await axios.get(url, { headers })
        return res.data.data
      } catch (e) {
        throw e.response.data.errors
      }
    },
    async getPhysicianBySpeciality(specialityID, fonteID, modalityID) {
      const url = `${baseUrl}/core/DicomPlus/PhysicianBySpeciality?SpecialityID=${specialityID}&SourceID=${fonteID}&ModalityID=${modalityID}`

      const res = await axios.get(url, {
        headers: {
          Authorization: token,
          RefreshToken: refreshToken
        }
      })
      const data = res.data?.data || []

      const listaMedicoUS = data
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => ({
          label: item.name,
          value: item.physicianId
        }))

      return { listaMedicoUS }
    },
    async getShowPhysician(sourceID, modalityID) {
      const headers = {
        Authorization: token,
        RefreshToken: refreshToken
      }

      const url = `${baseUrl}/core/DicomPlus/ShowPhysician?SourceID=${sourceID}&ModalityID=${modalityID}`
      try {
        const res = await axios.get(url, { headers })
        return res.data.data
      } catch (e) {
        console.error(e.response.data.errors)
        return { setPhysician: false, physicianRequired: false }
      }
    }
  }
}

export default mixin
